import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-approve-reject-prompt',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule],
  templateUrl: './approve-reject-prompt.component.html',
  styleUrl: './approve-reject-prompt.component.scss'
})
export class ApproveRejectPromptComponent {

  rejectionReason: string = ''
  loggedUserId: any;
  formSubmitted: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ApproveRejectPromptComponent>,
  ) {
    this.loggedUserId = localStorage.getItem("user_id")
  }

  cancelPrompt() {
    this.formSubmitted = false;
    this.dialogRef.close();
  }

  approvePrompt() {
    const postData = {
      prompt_id: this.data?.prompt_id,
      status:"PUBLISHED",
      curator_user_id: Number(this.loggedUserId),
      source_prompt_id: this.data?.source_prompt_id
    }
    this.dialogRef.close(postData);
  }

  rejectPrompt(form:any) {
    this.formSubmitted = true;
    if (form.valid && this.rejectionReason !== '') {
      const postData = {
        prompt_id: this.data?.prompt_id,
        status: "REJECTED",
        rejection_reason: this.rejectionReason,
        curator_user_id: Number(this.loggedUserId),
        source_prompt_id: this.data?.source_prompt_id
      }
      this.dialogRef.close(postData);
    } else {
      form.controls?.comments?.markAsTouched();
      // this.dialogRef.close();
    }
  }

}
